export const AircashMarketplaceBonusLabel = "Aircash Marketplace bonus";
